import type { MarketplaceDynamicFilter } from "@/types/api/marketplace";
import type {
  ProductFilter,
  ProductKeyword,
} from "@/types/api/marketplace-product";

export const MARKETPLACE_KEYWORDS_FILTER_TYPE = "keywords";

export interface MarketplaceFilterTransformResult {
  dynamic_filters: MarketplaceDynamicFilter[];
  filterMapping: Record<string, Record<number, string>>;
}

function mapFacetFilter(
  name: string,
  filter: ProductFilter,
  filterMapping: Record<string, Record<number, string>>
): MarketplaceDynamicFilter {
  const options = filter.entries.map((entry, index) => {
    const optionId = index + 1;
    if (!filterMapping[name]) {
      filterMapping[name] = {};
    }
    filterMapping[name][optionId] = entry.term;
    return {
      id: optionId,
      label: entry.title,
    };
  });

  return {
    type: name,
    label: filter.title,
    input_type: "checkbox",
    placement: "modal",
    options,
  };
}

function mapKeywordFilter(
  keywords: ProductKeyword[],
  filterMapping: Record<string, Record<number, string>>
): MarketplaceDynamicFilter | null {
  if (keywords.length === 0) return null;

  const mapping: Record<number, string> = {};
  const options = keywords.map((keyword, index) => {
    const optionId = index + 1;
    mapping[optionId] = keyword.name;
    return {
      id: optionId,
      label: keyword.name,
    };
  });

  filterMapping[MARKETPLACE_KEYWORDS_FILTER_TYPE] = mapping;

  return {
    type: MARKETPLACE_KEYWORDS_FILTER_TYPE,
    label: "Keywords",
    input_type: "checkbox",
    placement: "bar",
    bar_display: "chips",
    options,
  };
}

export function transformProductFiltersFromAPI(
  apiFilters: Record<string, ProductFilter>,
  keywords: ProductKeyword[] = []
): MarketplaceFilterTransformResult {
  const dynamic_filters: MarketplaceDynamicFilter[] = [];
  const filterMapping: Record<string, Record<number, string>> = {};

  Object.entries(apiFilters).forEach(([name, filter]) => {
    dynamic_filters.push(mapFacetFilter(name, filter, filterMapping));
  });

  const keywordFilter = mapKeywordFilter(keywords, filterMapping);
  if (keywordFilter) {
    dynamic_filters.push(keywordFilter);
  }

  return { dynamic_filters, filterMapping };
}
